import React, { useState } from 'react';
import { SearchIcon, MapPinIcon, PackageIcon, CheckCircleIcon, TruckIcon, ArrowRightIcon } from 'lucide-react';
import { MaterialItem } from './MaterialPreparation';
interface OrderMaterialsListProps {
  materials: MaterialItem[];
  onMaterialSelect: (material: MaterialItem) => void;
}
export function OrderMaterialsList({
  materials,
  onMaterialSelect
}: OrderMaterialsListProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState<'all' | 'pending' | 'in-progress' | 'completed'>('all');
  const filteredMaterials = materials.filter(material => {
    const matchesSearch = material.name.toLowerCase().includes(searchTerm.toLowerCase()) || material.id.toLowerCase().includes(searchTerm.toLowerCase()) || material.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterStatus === 'all' || material.status === filterStatus;
    return matchesSearch && matchesFilter;
  });
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon size={16} className="text-green-500" data-id="element-1176" />;
      case 'in-progress':
        return <PackageIcon size={16} className="text-blue-500" data-id="element-1177" />;
      default:
        return <TruckIcon size={16} className="text-gray-500" data-id="element-1178" />;
    }
  };
  return <div data-id="element-1179">
      <div className="mb-4" data-id="element-1180">
        <h4 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-1181">
          Benötigte Materialien
        </h4>
        <p className="text-sm text-gray-600" data-id="element-1182">
          Wählen Sie ein Material aus, um mit der Bereitstellung zu beginnen
        </p>
      </div>
      <div className="flex flex-col md:flex-row gap-3 mb-4" data-id="element-1183">
        <div className="flex-1 relative" data-id="element-1184">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1185">
            <SearchIcon size={18} className="text-gray-400" data-id="element-1186" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md" placeholder="Material oder Lagerort suchen..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1187" />
        </div>
        <div data-id="element-1188">
          <select className="block w-full p-2 border border-gray-300 rounded-md" value={filterStatus} onChange={e => setFilterStatus(e.target.value as any)} data-id="element-1189">
            <option value="all" data-id="element-1190">Alle Status</option>
            <option value="pending" data-id="element-1191">Ausstehend</option>
            <option value="in-progress" data-id="element-1192">In Bearbeitung</option>
            <option value="completed" data-id="element-1193">Abgeschlossen</option>
          </select>
        </div>
      </div>
      <div className="space-y-3" data-id="element-1194">
        {filteredMaterials.map(material => <div key={material.id} className={`border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer ${material.status === 'completed' ? 'bg-green-50 border-green-200' : material.status === 'in-progress' ? 'bg-blue-50 border-blue-200' : 'bg-white border-gray-200'}`} onClick={() => onMaterialSelect(material)} data-id="element-1195">
            <div className="flex justify-between items-start" data-id="element-1196">
              <div data-id="element-1197">
                <div className="flex items-center" data-id="element-1198">
                  {getStatusIcon(material.status)}
                  <h5 className="font-medium text-gray-900 ml-2" data-id="element-1199">
                    {material.name}
                  </h5>
                </div>
                <p className="text-sm text-gray-500" data-id="element-1200">
                  Artikel-Nr: {material.id}
                </p>
                <div className="flex items-center mt-1 text-sm text-gray-600" data-id="element-1201">
                  <MapPinIcon size={14} className="mr-1" data-id="element-1202" />
                  <span data-id="element-1203">
                    {material.location}, Zone {material.zone}
                  </span>
                </div>
              </div>
              <div className="flex flex-col items-end" data-id="element-1204">
                <div className="text-lg font-semibold text-gray-900" data-id="element-1205">
                  {material.quantity} {material.unit}
                </div>
                <div className="text-sm text-gray-600" data-id="element-1206">
                  {material.scanned} / {material.pallets} Paletten
                </div>
                <button className="mt-2 flex items-center text-[#8DC63F] hover:text-[#7AB929] text-sm" data-id="element-1207">
                  <span data-id="element-1208">Bereitstellen</span>
                  <ArrowRightIcon size={14} className="ml-1" data-id="element-1209" />
                </button>
              </div>
            </div>
            {material.status !== 'pending' && <div className="mt-2" data-id="element-1210">
                <div className="text-xs text-gray-500 mb-1" data-id="element-1211">
                  Fortschritt: {material.scanned} von {material.pallets}{' '}
                  Paletten gescannt
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1212">
                  <div className="bg-[#8DC63F] h-2 rounded-full" style={{
              width: `${material.scanned / material.pallets * 100}%`
            }} data-id="element-1213"></div>
                </div>
              </div>}
          </div>)}
        {filteredMaterials.length === 0 && <div className="text-center py-6 bg-gray-50 rounded-lg border border-gray-200" data-id="element-1214">
            <PackageIcon size={32} className="mx-auto text-gray-400 mb-2" data-id="element-1215" />
            <p className="text-gray-500" data-id="element-1216">
              Keine Materialien gefunden, die den Filterkriterien entsprechen.
            </p>
          </div>}
      </div>
    </div>;
}